import { render, staticRenderFns } from "./SocialWallModalShell.vue?vue&type=template&id=b24af41a&scoped=true"
import script from "./SocialWallModalShell.vue?vue&type=script&lang=js"
export * from "./SocialWallModalShell.vue?vue&type=script&lang=js"
import style0 from "./SocialWallModalShell.vue?vue&type=style&index=0&id=b24af41a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24af41a",
  null
  
)

export default component.exports